import en from '../locale/translations/en.json'
import de from '../locale/translations/de.json'
import fr from '../locale/translations/fr.json'
import es from '../locale/translations/es.json'
import ja from '../locale/translations/ja.json'
import { type InitOptions } from 'i18next'

export default {
  resources: { en, de, fr, es, ja },
  supportedLngs: ['en', 'de', 'fr', 'es', 'ja'],
  missingInterpolationHandler: () => '',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  react: { useSuspense: false },
  returnObjects: true,
} satisfies InitOptions
